import { Box } from '@medly-components/core';
import styled from 'styled-components';

export const StickyButtonWrapper = styled(Box)`
    z-index: 2;
    background: none;
    padding: 0;
    position: relative;
    display: flex;
    gap: 1.6rem;
    button,
    a {
        flex: 1;
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.M.max}px) {
        z-index: 3;
        justify-content: center;
        padding: 0.8rem 2.4rem;
        right: 0;
        bottom: 0;
        margin: 0;
        border-radius: 0;
        position: fixed;
        width: fill-available;
        background: white;
    }
`;
